import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { UncontrolledAccordion } from "reactstrap";
import FilterTraitType from "./utils/FilterTraitType";

/**
 * Table container used as app default landing page
 */
const TokenTraitFilter = (props) => {
  const traitTypes = useSelector((state) => state.traitTypes.idsList);

  if (traitTypes.length <= 0) return null;

  return (
    <UncontrolledAccordion className="mb-3" flush>
      {traitTypes.map((traitTypeId) => (
        <FilterTraitType
          key={traitTypeId}
          traitTypeId={traitTypeId}
          handleFilterChange={props.handleFilterChange}
          filters={props.filters}
        />
      ))}
    </UncontrolledAccordion>
  );
};

/**  define proptypes for TokenTraitFilter  */
TokenTraitFilter.propTypes = {
  handleFilterChange: PropTypes.func,
  filters: PropTypes.object,
};

/**  define defaultProps for TokenTraitFilter  */
TokenTraitFilter.defaulProps = {};

/**  define proptype for the 'translation' function  */
TokenTraitFilter.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default TokenTraitFilter;
